export default "__VITE_ASSET__49ca77ea__"